import React, { FC } from 'react';

import { Machine } from '@interfaces/machines';
import ColorWrapper from '@styles/colors';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { getMachineImageData } from '@helpers';
import { IMAGE_HANDLING_CONTEXT, KEYS_TAGS } from '@components/imageHandling/common';
import { SearchItemType } from '@interfaces/base';
import SimpleSearchLineWrapper, { SimpleSearchLineWrapperProps } from '@components/search/common/SimpleSearchLineWrapper';
import { ImageParams } from '@interfaces/search';

interface SearchMachinesProps
  extends Pick<SimpleSearchLineWrapperProps<Machine>, 'C' | 'isPopupMode' | 'popupWidth' | 'loaded' | 'attachMode' | 'scale' | 'font' | 'width'> {
  searchResult: Machine[];
  onItemSelect: (item: Machine, itemType: SearchItemType) => void;
}

const SearchMachines: FC<SearchMachinesProps> = ({ isPopupMode, onItemSelect, scale = initialScale, font = initialFont, ...rest }) => {
  const onItemPress = (machine: Machine) => {
    if (isPopupMode && onItemSelect) {
      onItemSelect(machine, 'Machine');
      return;
    }
  };

  const getImageParams = (machine: Machine): ImageParams => {
    const machineImageData = getMachineImageData(machine);

    return {
      documentId: machineImageData?.machineDocumentId,
      imageHash: machineImageData?.imageRandomHash,
      imageData: { ...machineImageData?.imageData, rotationAngle: machineImageData?.imageRotationAngle },
      width: scale(66),
      height: scale(44),
      contextId: KEYS_TAGS.Machine,
      contextCode: IMAGE_HANDLING_CONTEXT.Machine,
    };
  };

  return (
    <SimpleSearchLineWrapper
      keyExtractor={(machine) => machine.machineId}
      getImageParams={getImageParams}
      isPopupMode={isPopupMode}
      onItemSelect={(machine) => onItemPress(machine)}
      getText={(machine) => machine.fullName}
      scale={scale}
      font={font}
      {...rest}
    />
  );
};

export default ColorWrapper(SearchMachines);
